export default __webpack_public_path__ + "static/media/smokey.0dd8f930.png";